export default __webpack_public_path__ + "static/media/python1.09df56eb.png";